import { OffersPromoRepository } from "../Repository/OffersPromoRepository";

export interface DeleteRemoveOfferItemUseCase {
    invoke: (rowId : string, itemId : number) => Promise<boolean>;
  }
  
  export class RemoveOfferItem implements DeleteRemoveOfferItemUseCase {
    private offersPromoRepo: OffersPromoRepository;
    constructor(_OffersPromoRepo: OffersPromoRepository) {
      this.offersPromoRepo = _OffersPromoRepo;
    }
  
    async invoke(rowId : string, itemId : number){
       
        if(!rowId){
            throw new Error(
                "Your todo should have at leat 2 characters."
              );
        }
         
        const deleted  = await this.offersPromoRepo.removeOfferItem(rowId, itemId);
        return deleted;
    }
  }